/* unplugin-vue-components disabled */import script from "./OrderDetailCard.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderDetailCard.vue?vue&type=script&setup=true&lang=js"

import "./OrderDetailCard.vue?vue&type=style&index=0&id=6b68ecd5&lang=scss"

const __exports__ = script;

export default __exports__